export default "/eye-open.png"